import { runJsonGet } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'

export const fetchVehicleTypes = async () => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/infrastructure/vehicle-types/`
  )
  return data.vehicle_types
}
